module.exports = __webpack_public_path__ + "static/media/Icon User 24.f622c236.svg";